<h2 class="modal-title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  {{ data.question }}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button *ngFor="let option of data.options" [mat-dialog-close]="option">{{ option.name }}</button>
</mat-dialog-actions>
